<div class="d-flex mb-2" *transloco="let t">
    <div class="w-100">
        <h1>{{ t('expired-domains.page-title') }}</h1>
    </div>
</div>

<td-expired-domains-table></td-expired-domains-table>
